import type * as lazyIndex from './lazyIndex';
import {
    createLazyComponent,
    LazyModule,
    LazyAction,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import {
    activityFeedNotificationAction,
    reactionNotificationAction,
    unifiedStorageQuotaNotificationAction,
} from 'owa-app-notifications-core';
import { onWebpushNotificationClickedAction } from 'owa-webpush-notifications/lib/actions/onWebpushNotificationClickedAction';
import type { NotificationPaneProps } from './components/NotificationPane';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "InAppNotifications"*/ './lazyIndex'),
    { name: 'InAppNotifications' }
);

export const lazyLaunchTaskReminder: LazyAction<
    typeof lazyIndex.launchTaskReminder,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.launchTaskReminder);
export const lazyPlayNewMailNotificationSound: LazyAction<
    typeof lazyIndex.playNewMailNotificationSound,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.playNewMailNotificationSound);
export const lazyPlayReactionNotificationSound: LazyAction<
    typeof lazyIndex.playReactionNotificationSound,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.playReactionNotificationSound);
export const lazyPlayReminderNotificationSound: LazyAction<
    typeof lazyIndex.playReminderNotificationSound,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.playReminderNotificationSound);
export const lazyPlayCalendarDesktopNotificationSound: LazyAction<
    typeof lazyIndex.playCalendarDesktopNotificationSound,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.playCalendarDesktopNotificationSound);
export const lazyGetSoundOptionForNotificationType: LazyAction<
    typeof lazyIndex.getSoundOptionForNotificationType,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getSoundOptionForNotificationType);
export const NotificationPane: LazyComponent<NotificationPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.NotificationPane);
export const AutomaticRepliesNotificationHost: LazyComponent<{}, unknown, void> =
    createLazyComponent(lazyModule, m => m.AutomaticRepliesNotificationHost);
export const ProjectionRemindersPane: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.ProjectionRemindersPane
);
export const lazyGetCalendarEvent: LazyAction<
    typeof lazyIndex.getCalendarEvent,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getCalendarEvent);

registerLazyOrchestrator(
    activityFeedNotificationAction,
    lazyModule,
    m => m.onActivityFeedNotification
);
registerLazyOrchestrator(reactionNotificationAction, lazyModule, m => m.onReactionNotification);
registerLazyOrchestrator(
    unifiedStorageQuotaNotificationAction,
    lazyModule,
    m => m.onUSQNotification
);
registerLazyOrchestrator(
    onWebpushNotificationClickedAction,
    lazyModule,
    m => m.onWebpushNotificationClickedOrchestrator
);
